import axios from 'axios'
import {API_URL} from '../constants';

import DataUtil from '../utilities/DataUtil';

const ITEMS_API_URL = `${API_URL}/items`;
const ITEMMAPPINGS_API_URL = `${API_URL}/itemmappings`;

class ItemDataService {

    retrieveItems() {
        let s = localStorage.getItem("list_item");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }

        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("list_item", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            localStorage.setItem("list_item", '[]');
            return error;
        });
    }

    retrieveDHLMasters(){
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findDHLMasters`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveItemMappings() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMMAPPINGS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    retrieveBy(searchValue, shopName, detailsRequired) {
         let details = 0;
        if (detailsRequired == 1){
            details = 1;
        }
        const token = sessionStorage.getItem('token');
        if ((searchValue === undefined || searchValue.trim().length < 1) && (shopName === undefined || shopName.trim().length < 1)){
            if (details === 1){
                return axios.get(`${ITEMS_API_URL}/findAllByDetails?details=${details}`,
                    { headers: { 'Authorization': `Bearer ${token}` } }
                ).then(response => {
                    return response.data;
                }).catch(error => {
                    return error;
                });
            }
            return axios.get(`${ITEMS_API_URL}/findAll`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }

        let encodedSearchValue = encodeURIComponent(searchValue);

        return axios.get(`${ITEMS_API_URL}/findBySkuAndShop?searchValue=${encodedSearchValue}&shop=${shopName}&details=${details}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveBy2(searchValue, shopName, detailsRequired) {
         let details = 0;
        if (detailsRequired == 1){
            details = 1;
        }
        const token = sessionStorage.getItem('token');
        if ((searchValue === undefined || searchValue.trim().length < 1) && (shopName === undefined || shopName.trim().length < 1)){
            if (details === 1){
                return axios.get(`${ITEMS_API_URL}/findAllByDetails?details=${details}`,
                    { headers: { 'Authorization': `Bearer ${token}` } }
                ).then(response => {
                    return response.data;
                }).catch(error => {
                    return error;
                });
            }
            return axios.get(`${ITEMS_API_URL}/findAll`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }

        return axios.post(`${ITEMS_API_URL}/findBySkuAndShop2`, { searchValue: searchValue, shop: shopName, details: details},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    } 

    retrieveByShopAndBy(searchValue, detailsRequired) {
        let details = 0;
        if (detailsRequired == 1){
            details = 1;
        }
        const token = sessionStorage.getItem('token');
        if (searchValue === undefined || searchValue.trim().length < 1){
            return axios.get(`${ITEMS_API_URL}/findByShop?details=${details}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        } else {
            let encodedSearchValue = encodeURIComponent(searchValue);
            return axios.get(`${ITEMS_API_URL}/findByShopAndBy?searchValue=${encodedSearchValue}&details=${details}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }
    }

    uploadDhl(files) {
        let formData = new FormData();
        for(var i=0; i<files.length; i++){
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMS_API_URL}/importItemDetails`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    } 

    retrieveItemMappingsBy(searchValue) {
        const token = sessionStorage.getItem('token');
        if (searchValue === undefined || searchValue.trim().length < 1){
            return axios.get(`${ITEMMAPPINGS_API_URL}/findAll`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        } else {
            return axios.get(`${ITEMMAPPINGS_API_URL}/findBy/${searchValue}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }
    }

    retrieveItemMappingsByShopAndBy(searchValue) {
        let encodedSearchValue = encodeURIComponent(searchValue);
        const token = sessionStorage.getItem('token');
        if (searchValue === undefined || searchValue.trim().length < 1){
            return axios.get(`${ITEMMAPPINGS_API_URL}/findByShop`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        } else {
            return axios.get(`${ITEMMAPPINGS_API_URL}/findByShopAndBy?searchValue=${encodedSearchValue}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            ).then(response => {
                return response.data;
            }).catch(error => {
                return error;
            });
        }
    }          

    retrieveById(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findById/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveBySku(sku) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findBySku/${sku}?details=0`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveBySku2(sku) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMS_API_URL}/findBySku2`, {sku: sku, details: 0},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }


    retrieveImagesOfItem(itemId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findImagesByItemId/${itemId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadItemImages(files, id) {
        let formData = new FormData();
        for(var i=0; i<files.length; i++){
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMS_API_URL}/uploadFiles/${id}`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    save(item) {
        console.log("save item", item);
        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMS_API_URL}/save`, item,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveItemMapping(item) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMMAPPINGS_API_URL}/save`, item,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    async update(item) {
        const token = sessionStorage.getItem('token');
        return await axios.put(`${ITEMS_API_URL}/update`, item,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    async updateItemMapping(item) {
        const token = sessionStorage.getItem('token');
        return await axios.put(`${ITEMMAPPINGS_API_URL}/update`, item,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${ITEMS_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteItemMapping(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${ITEMMAPPINGS_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    

    downloadImage(imageId, contentType) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findImageById/${imageId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            var binary = null;
            if (contentType === "application/pdf"){
                binary = response.data;
            }else if(contentType === "text/plain"){
                binary = response.data;
            }
            else{
                binary = DataUtil.fixBinary(atob(response.data));
            }
            
            const file = new Blob(
                [binary], 
                {type: contentType}
                );

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
        })
        .catch(error => {
            console.log(error);
        });
    } 
    
    deleteImage(imageId) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${ITEMS_API_URL}/deleteImageById/${imageId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcel(){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${ITEMS_API_URL}/exportItems`, {},
            { 
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob' 
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }  

    exportDhl(){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${ITEMS_API_URL}/exportItemDetails`, {},
            { 
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob' 
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveDHLsBySku(sku){
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findItemDetailsBySku?sku=${sku}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteDHL(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${ITEMS_API_URL}/deleteDHLById/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    findDHLNoteBy(key){
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findDHLNoteBy?key=${key}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveDHLNoteBy(key, note){
        const token = sessionStorage.getItem('token');
        let dhlNote = {
            code: key,
            details: note
        }
        return axios.post(`${ITEMS_API_URL}/saveDHLNoteByKey`, dhlNote, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteDHLNoteByKey(key){
        const token = sessionStorage.getItem('token');
        return axios.post(`${ITEMS_API_URL}/deleteDHLNoteByKey?key=${key}`, {}, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveKV(key, details){
        const token = sessionStorage.getItem('token');
        let kv = {
            code: key,
            details: details
        }
        return axios.post(`${ITEMS_API_URL}/saveKV`, kv, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    findKvBy(key){
        const token = sessionStorage.getItem('token');
        return axios.get(`${ITEMS_API_URL}/findKvBy?key=${key}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new ItemDataService()